<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="tabs is-right" :class="{ 'is-fullwidth': $mq === 'mobile' }">
        <ul>
          <li
            v-for="(item, index) in links"
            :key="index"
            :class="{ 'is-active': $route.name === item.name }"
          >
            <router-link :to="{ name: item.name }">
              {{ item.label }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StockCompareTabs',
  computed: {
    links() {
      return [
        { name: 'stockcompare', label: 'Dashboard' },
        { name: 'stockcompare-sellers', label: 'Sellers' }
      ]
    },
    title() {
      return this.$route.name === 'stockcompare' ? 'Dashboard' : 'Compare Stock'
    },
    titleIcon() {
      return this.$route.name === 'stockcompare' ? 'fal fa-home' : 'fal fa-cars'
    }
  }
}
</script>
